export default "__VITE_ASSET__D58Zr9dp__"